import React from "react";
import { BadgeCheck, Building2, Receipt, Store } from "lucide-react";
import { SectorSection } from "./ExchangeGovSection";

const CARDS = [
  {
    id: "talent-pipeline", Icon: BadgeCheck, title: "Pre-Certified Talent Pipeline",
    metrics: [
      { label: "Work-ready candidates", to: 418 },
      { label: "Placement rate", to: 87, suffix: "%" },
      { label: "90-day retention", to: 91, suffix: "%" },
    ],
    bars: [42, 55, 61, 72, 80, 89],
  },
  {
    id: "wotc", Icon: Receipt, title: "WOTC & Hiring Tax Credits",
    metrics: [
      { label: "Credits captured", to: 642, prefix: "$", suffix: "K" },
      { label: "Eligible hires", to: 254 },
      { label: "Filings automated", to: 100, suffix: "%" },
    ],
    bars: [30, 41, 53, 66, 78, 92],
  },
  {
    id: "esg", Icon: Building2, title: "Corporate Sponsorship & ESG Impact",
    metrics: [
      { label: "Sponsored beds", to: 120 },
      { label: "Lives impacted", to: 2380 },
      { label: "ESG report ready", to: 100, suffix: "%" },
    ],
    bars: [50, 58, 64, 75, 83, 95],
  },
  {
    id: "marketplace", Icon: Store, title: "Local Business Partner Marketplace",
    metrics: [
      { label: "Partner vendors", to: 76 },
      { label: "Spending kept local", to: 1.1, decimals: 1, prefix: "$", suffix: "M" },
      { label: "Discount programs", to: 23 },
    ],
    bars: [36, 47, 59, 68, 77, 86],
  },
];

export const COMMERCE_CUES = [
  { phrase: "talent pipeline", target: "exchange-commerce-card-talent-pipeline" },
  { phrase: "tax credits", target: "exchange-commerce-card-wotc" },
  { phrase: "ESG", target: "exchange-commerce-card-esg" },
  { phrase: "marketplace", target: "exchange-commerce-card-marketplace" },
];

// Beat 04 — Commerce, Corporate & Small Business.
export default function ExchangeCommerceSection() {
  return (
    <SectorSection sector="commerce" beatId="commerce" eyebrow="// 04 · Sector" title="Commerce, Corporate & Small Business" cards={CARDS}
      dockLabel="What employers get"
      dockItems={["Pre-certified, work-ready hires", "WOTC credits flagged and filed automatically", "Board-ready ESG impact reporting", "A local marketplace that keeps dollars in the neighborhood"]} />
  );
}
